import getEmbeddedApiConfigurationState from '@/lib/getEmbeddedApiConfigurationState.js';

const mergeIntegrationPreservingApiConfiguration = (existing, incoming) => {
  const configurationState = getEmbeddedApiConfigurationState(existing);
  const apiConfigured = configurationState === 'configured' ? true : configurationState === 'automatic' ? false : existing.apiConfigured;
  // Settings saves and workflow reads cannot change configuration intent.
  // Keep the current marker even if this response is older.
  return { ...existing, ...incoming, apiConfigured, settings: { ...incoming.settings, apiConfigured } };
};

export default mergeIntegrationPreservingApiConfiguration;
